import React from "react"
import Avatar from "material-ui/Avatar"
import Chip from "material-ui/Chip"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import ImageLoader from "../misc/ImageLoader"
import AddEquipmentDialogForChip from "./AddEquipmentDialogForChip"
import * as punchActions from "../../actions/PunchActions"
import { IEquipmentDocument } from "../../models"
import { grey500, grey700, green500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
interface IProps {
    canChange: boolean
    defaultEquipmentId: string
    maxWidth?: boolean
    setEquipmentList(equipments: IEquipmentDocument[]): void

    //Employee->Timecard->PunchDrawerTable
    isPunchListTable?: boolean
    useEditablePunchTableDataStore?: boolean //if isPunchListTable is true, dont need to set this value
    equipmentColWidth?: number
}
interface IState {
    selectedEqipmentList: IEquipmentDocument[]
    showAddEquipment: boolean
}

export default class EquipmentChip extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedEqipmentList: [],
            showAddEquipment: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.props.defaultEquipmentId && (
            this.props.defaultEquipmentId !== AccountStore.DiffEquipmentId ?
                punchActions.getEquipment(this.props.defaultEquipmentId, this.props.isPunchListTable || this.props.useEditablePunchTableDataStore).then(equipment =>
                    this.setState({ selectedEqipmentList: [equipment] })
                ) :
                this.setState({ selectedEqipmentList: [AccountStore.DiffEquipment as IEquipmentDocument] })
        )
    }

    handleRequestDelete(equipment) {
        const selectedEqipmentList = this.state.selectedEqipmentList.slice()
        if (selectedEqipmentList.indexOf(equipment) > -1) {
            selectedEqipmentList.splice(selectedEqipmentList.indexOf(equipment), 1)
        }
        this.setState({ selectedEqipmentList })
        this.props.setEquipmentList(selectedEqipmentList)
    }

    handleAddEquipment() {
        this.setState({
            showAddEquipment: !this.state.showAddEquipment
        })
    }

    handleAddEquipmentList(equipmentList) {
        this.handleAddEquipment()
        const selectedEqipmentList = this.state.selectedEqipmentList.slice()
        equipmentList.forEach((item) => {
            const exist = selectedEqipmentList.find((selectedItem) => {
                return selectedItem.Id === item.Id
            })
            if (!exist) selectedEqipmentList.push(item)
        })
        this.setState({
            selectedEqipmentList
        })
        this.props.setEquipmentList(selectedEqipmentList)
    }

    render() {
        const { selectedEqipmentList } = this.state
        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                {!this.props.isPunchListTable &&
                    <i className="fa fa-wrench" style={{ marginRight: 10 }} />
                }
                <div>
                    <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>{!this.props.isPunchListTable && strings.Equipment}</div>
                    <div>
                        {selectedEqipmentList.map((item, key) => {
                            const itemName = `${item.Name}${item.ExternalId ? `-${item.ExternalId}` : ""}`
                            return (
                                <Chip
                                    data-intercom-target={"Select-Equipment"}
                                    key={key}
                                    style={{ justifyContent: this.props.isPunchListTable && "space-between", margin: 2, height: 35, width: this.props.isPunchListTable ? this.props.equipmentColWidth : "min-content" }}
                                    onRequestDelete={this.props.canChange ? this.handleRequestDelete.bind(this, item) : null}
                                >
                                    {item.ImageS3Url &&
                                        <Avatar style={{ marginRight: 5, width: 37, height: 37 }}>
                                            <ImageLoader url={item.ImageS3Url} fixedHeight={60} avatar />
                                        </Avatar>
                                    }
                                    <div
                                        className="TextOverflow"
                                        title={itemName}
                                        style={{ color: item.Id === AccountStore.DiffEquipmentId && green500, marginLeft: item.ImageS3Url && -12, maxWidth: this.props.isPunchListTable && this.props.equipmentColWidth - (item.ImageS3Url ? 80 : 40), fontSize: this.props.isPunchListTable && 12 }}
                                    >
                                        {itemName}
                                    </div>
                                </Chip>
                            )
                        })}
                        {this.props.canChange && selectedEqipmentList.length === 0 &&
                            <IconButton
                                data-intercom-target={"Btn-Open-Equpment-Selection-Dialog"}
                                style={{ height: this.props.isPunchListTable ? 18 : 35, width: this.props.isPunchListTable ? 18 : 35, marginTop: this.props.isPunchListTable && 10, padding: 0, margin: 0, display: "inline-block" }}
                                iconStyle={{ color: this.props.isPunchListTable ? grey500 : grey700, fontSize: this.props.isPunchListTable ? 18 : 24 }}
                                onTouchTap={this.handleAddEquipment}
                            >
                                <FontIcon className="fa fa-plus-circle" />
                            </IconButton>
                        }
                    </div>
                    {this.state.showAddEquipment &&
                        <AddEquipmentDialogForChip
                            open={this.state.showAddEquipment}
                            handleAddEquipmentList={this.handleAddEquipmentList}
                            handleClose={this.handleAddEquipment}
                        />
                    }
                </div>
            </div>
        )
    }
}